<div
  class="ui-table-toolbar"
  [class.ui-table-toolbar--stacked]="isStacked">
  <div class="ui-table-toolbar__header">
    <div class="ui-table-toolbar__left">
      <h2 class="ui-table-toolbar__title">{{ title }}</h2>
      <p class="ui-table-toolbar__subtitle" *ngIf="subtitle">{{ subtitle }}</p>
    </div>
    <div class="ui-table-toolbar__actions">
      <ng-container *ngIf="isStacked">
        <app-ui-button
          *ngIf="showCreate"
          variant="primary"
          icon="add"
          [label]="createLabel"
          (clicked)="onCreate()">
        </app-ui-button>
        <ng-container *ngFor="let action of visibleSecondaryActions">
          <app-ui-button
            [variant]="action.variant || 'outline'"
            [icon]="action.icon || ''"
            [label]="action.label"
            [disabled]="!!action.disabled"
            (clicked)="onSecondaryAction(action.id)">
          </app-ui-button>
        </ng-container>
      </ng-container>

      <ng-container *ngIf="!isStacked">
        <app-ui-search-input
          [placeholder]="searchPlaceholder"
          [value]="searchValue"
          (valueChange)="onSearchValueChange($event)"
          (enter)="onSearch()">
        </app-ui-search-input>
        <app-ui-button
          variant="primary"
          icon="search"
          [label]="searchLabel"
          (clicked)="onSearch()">
        </app-ui-button>
        <app-ui-filter-select
          *ngFor="let filter of filters"
          [label]="filter.label"
          [options]="filter.options"
          [value]="filter.value"
          [showIcon]="filter.showIcon !== false"
          (valueChange)="onFilterChange(filter.key, $event)">
        </app-ui-filter-select>
        <app-ui-button
          *ngIf="showExport"
          variant="outline"
          icon="download"
          label="Export"
          (clicked)="onExport()">
        </app-ui-button>
        <ng-container *ngFor="let action of visibleSecondaryActions">
          <app-ui-button
            [variant]="action.variant || 'outline'"
            [icon]="action.icon || ''"
            [label]="action.label"
            [disabled]="!!action.disabled"
            (clicked)="onSecondaryAction(action.id)">
          </app-ui-button>
        </ng-container>
        <app-ui-button
          *ngIf="showCreate"
          variant="primary"
          icon="add"
          [label]="createLabel"
          (clicked)="onCreate()">
        </app-ui-button>
      </ng-container>
    </div>
  </div>

  <div class="ui-table-toolbar__filter-row" *ngIf="isStacked">
    <ng-content select="[uiToolbarFilters]"></ng-content>
    <app-ui-filter-select
      *ngFor="let filter of filters"
      [label]="filter.label"
      [options]="filter.options"
      [value]="filter.value"
      [showIcon]="filter.showIcon !== false"
      (valueChange)="onFilterChange(filter.key, $event)">
    </app-ui-filter-select>
    <app-ui-button
      variant="success"
      [label]="searchLabel"
      (clicked)="onSearch()">
    </app-ui-button>
    <app-ui-button
      *ngIf="showReset"
      variant="primary"
      [label]="resetLabel"
      (clicked)="onReset()">
    </app-ui-button>
    <div class="ui-table-toolbar__search-grow">
      <app-ui-search-input
        [placeholder]="searchPlaceholder"
        [value]="searchValue"
        (valueChange)="onSearchValueChange($event)"
        (enter)="onSearch()">
      </app-ui-search-input>
    </div>
  </div>
</div>
